module.exports = __webpack_public_path__ + "static/img/logo.85ac4708.svg";